import {Component, Inject, Input, OnInit} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {MatFormFieldAppearance} from '@angular/material/form-field';
import {BaseFormComponent, ValidationError} from 'nc-shared';

@Component({
  selector: 'nc-datepicker',
  templateUrl: './nc-datepicker.component.html',
  styleUrls: ['./nc-datepicker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: NcDatepickerComponent,
      multi: true
    },
  ]
})
export class NcDatepickerComponent extends BaseFormComponent implements OnInit {
  @Input() appearance: MatFormFieldAppearance = 'outline';

  private DOT_CODE = 46;
  private ZERO_CODE = 48;
  private NINE_CODE = 57;

  constructor(@Inject('ValidationErrorMap') public errorMap: Record<string, ValidationError>) {
    super(errorMap);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  dateFormatFilter(event): boolean {
    const code = event.keyCode;
    const isDot = code === this.DOT_CODE;
    const isNumber = code >= this.ZERO_CODE && code <= this.NINE_CODE;
    return isDot || isNumber;
  }
}
